import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isMobileMedia } from 'utils/media';
import MenuItemPageFooter from 'menus/containers/MenuItemPageFooter';
import BaseLayout from 'base/layouts/Layout';
import MenuLayout from 'menus/layouts/MenuLayout';

const LAYOUT_PADDING = {
  pl: 0,
  pr: 0,
  pb: 3
};

class MenuItemPageLayout extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]).isRequired,
    isFetching: PropTypes.bool
  };
  render() {
    const { isFetching } = this.props;
    if (isMobileMedia()) {
      /**
       * Use this layout if rendering menu item page in mobile (full page)
       */
      return (
        <BaseLayout
          hideNav
          layoutPadding={LAYOUT_PADDING}
          mobileFooter={<MenuItemPageFooter />}
          hideBrandFooterOnMobile
          isModal
          isFetching={isFetching}
        >
          {this.props.children}
        </BaseLayout>
      );
    } else {
      return <MenuLayout>{this.props.children}</MenuLayout>;
    }
  }
}

const mapStateToProps = state => ({
  isFetching: state.menuItemsDetail.isFetching
});

export default connect(mapStateToProps)(MenuItemPageLayout);
